import { configureStore } from "@reduxjs/toolkit";
import { appListenerMiddleware } from "./middleware/appListenerMiddleware";
import { createAllListeners } from "./middleware/listeners";
import { reducer } from "./reducers";

createAllListeners();

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().prepend(appListenerMiddleware.middleware);
  },
});
